<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error size="md" v-else-if="error" with-default :state="state" />
    <div
      v-else
      class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start ba-m-auto"
    >
      <h4
        class="ba-w-full ba-text-xl md:ba-text-2xl ba-mb-4 xs:ba-mb-6 ba-text-center ba-text-white"
      >
        {{ $t("recovery.title") }}
      </h4>
      <p v-if="false" class="ba-text-center ba-text-sm ba-mb-4 sm:ba-mb-10">
        <span v-if="settings.loginAsOrg">{{ $t("recovery.org") }}</span>
        <span v-else>{{ $t("recovery.person") }}</span>
      </p>
      <p class="ba-text-center ba-text-sm ba-mb-4 ba-w-full ba-text-white">
        <span class="far fa-envelope ba-text-sm ba-mb-1 ba-mr-1" />
        {{ $t("recovery.description") }}
        <br />{{ $t("recovery.details") }}
      </p>
      <form
        @submit.prevent="recoveryFormSubmit"
        class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-max-w-xs ba-relative ba-pt-4"
      >
        <p
          v-if="formError"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("recovery.formError") }}
        </p>
        <p
          v-if="formSuccess"
          class="success form-message ba-text-center ba-text-sm"
        >
          {{ $t("recovery.formSuccess") }}
        </p>
        <p
          v-if="formFieldsRequired"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("recovery.formFieldsRequired") }}
        </p>
        <p
          v-if="formInvalidEmail"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("recovery.formInvalidEmail") }}
        </p>
        <vis-form-input
          v-model="form.email"
          :disabled="formLoading"
          label="Email"
          type="text"
          icon="fas fa-envelope"
          autocomplete="off"
        />
        <button
          type="submit"
          :disabled="formLoading"
          class="btn ba-w-full ba-max-w-xs btn--login"
        >
          {{ $t("button.next") }}
        </button>
      </form>
      <router-link
        :to="{ name: 'login', query: { state } }"
        class="forgot ba-block ba-text-center ba-w-full"
      >
        <span>{{ $t("backToLogin2") }}</span>
      </router-link>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import { getSettings } from "@/utils/settings";
import { recoveryMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-recovery",
  components: {
    VisLoginLayout
  },
  mixins: [recoveryMixin],
  data() {
    return {
      settings: getSettings()
    };
  },
  watch: {
    recoveryInfo() {
      if (!this.recoveryInfo?.canResetPassword) {
        this.$router.replace({ name: "login", query: { state: this.state } });
      }
    }
  }
};
</script>
